import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { observer } from 'mobx-react';

const GetUserInfo = gql`
  query UserInfo {
    userInfo {
      id
      
      email
      phone
      
      receiveNewsletter
      
      companyInformation
      companyName
      companyRegistrationNumber
      companyVatNumber
      companyVatValidationDate

      invoiceFirstName
      invoiceLastName
      
      invoiceStreet
      invoiceHouseNumber
      invoiceAddressLine1
      invoiceAddressLine2
      invoiceZip
      invoiceCity
      invoiceCountyState
      invoiceCountry

      anotherDeliveryAddress
      deliveryPhone
      deliveryStreet
      deliveryHouseNumber
      deliveryAddressLine1
      deliveryAddressLine2
      deliveryZip
      deliveryCity
      deliveryCountyState
      deliveryCountry

      saleTaxCertificate

      discount

      customerGroup {
        id
        name
        discount
        fields
        description
      }

      customerGroups {
        id
        name
        discount
        description
        fields
      }

      customerGroupsData
    }
  }
`;

interface IInputProps {
  children?: any;
}

interface IResponse {
  data: any;
}

@observer
class GetUserInfoQuery extends React.Component<ChildProps<IInputProps, IResponse>, {}> {
  public render() {
    const { userInfo }: any = this.props;
    return this.props.children({ userInfo });
  }
}

export default compose(
  graphql<IInputProps, IResponse>(GetUserInfo, {
    name: 'userInfo',
    options: props => ({
      fetchPolicy: 'network-only'
    })
  })
)(GetUserInfoQuery);



// WEBPACK FOOTER //
// ./src/components/Query/User/UserInfo.tsx